const STOREFRONT_ACCESS_TOKEN =  '6fdc11119a1c36a8ebb108fe41e93471'
const GRAPHQL_URL = 'https://mozaico111.myshopify.com/api/2021-07/graphql.json'

export const fetchWebsiteProducts = () => {
    const productQuery = `
        query getAllprods {
            products(first: 250, reverse: true, query:"status:active AND published_status:published") {
                edges {
                    node {
                        id
                        onlineStoreUrl
                        title
                        totalInventory
                        tags
                        featuredImage {
                            src: transformedSrc(maxWidth: 360)
                        }
                        priceRange {
                            minVariantPrice {
                                amount
                                currencyCode
                            }
                        }
                    }
                }
            }
        }
    `;

    return fetch(GRAPHQL_URL, {
        method: "POST",
        headers: {
            'Content-Type': 'application/graphql',
            "X-Shopify-Storefront-Access-Token": STOREFRONT_ACCESS_TOKEN
        },
        body: productQuery
    })
}

export const fetchWebsiteProductsByCat = (category) => {
    const productQuery = `
        query getCollectionByHandle {
            collectionByHandle(handle: "${category}") {
                id
                handle
                products(first: 250) {
                    edges {
                        node {
                            id
                            onlineStoreUrl
                            title
                            totalInventory
                            tags
                            featuredImage {
                                src: transformedSrc(maxWidth: 360)
                            }
                            priceRange {
                                minVariantPrice {
                                    amount
                                    currencyCode
                                }
                            }
                        }
                    }
                }
            }
        }
    `;

    return fetch(GRAPHQL_URL, {
        method: "POST",
        headers: {
            'Content-Type': 'application/graphql',
            "X-Shopify-Storefront-Access-Token": STOREFRONT_ACCESS_TOKEN
        },
        body: productQuery
    })
}

export const fetchWebsiteCollections = () => {
    const collectionQuery = `
    query {
        collections(first: 250) {
          edges {
            node {
              id
              title
              handle
              updatedAt
            }
          }
        }
      }
    `;

    return fetch(GRAPHQL_URL, {
        method: "POST",
        headers: {
            'Content-Type': 'application/graphql',
            "X-Shopify-Storefront-Access-Token": STOREFRONT_ACCESS_TOKEN
        },
        body: collectionQuery
    })
}
